// Libs
import { createConsoleLogger } from 'configcat-js';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// Utils
import {
  recurrenceOutput,
  documentChips
} from './inspectionTypeTransformations';

// Styles
const Wrapper = styled.article`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Item = styled.div`
  flex: 1 0 50%;
  margin-bottom: 1rem;

  button {
    margin: 0;
  }
`;

const Label = styled.h5`
  margin: 0;
`;

const Content = styled.p``;

const InspectionTypeCardDetails = ({
  market,
  category,
  inspectionInterval,
  remindBeforeDueDate,
  allDocuments,
  templateName,
  canUseInspectionIssuesWithWorkflow
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Item>
        <Label>{t('Market')}</Label>
        <Content>{market}</Content>
      </Item>
      <Item>
        <Label>{t('Category')}</Label>
        <Content>{category}</Content>
      </Item>
      <Item>
        <Label>{t('Recurs every')}</Label>
        {recurrenceOutput(t)(inspectionInterval)}
      </Item>
      <Item>
        <Label>{t('Window')}</Label>
        {recurrenceOutput(t)(remindBeforeDueDate)}
      </Item>
      <Item>
        <Label>{t('Documents')}</Label>
        {documentChips(allDocuments)}
      </Item>
      {canUseInspectionIssuesWithWorkflow && (
        <Item>
          <Label>{t('workflowTemplates.workflowTemplate')}</Label>
          {templateName || '-'}
        </Item>
      )}
      
    </Wrapper>
  );
};

export default InspectionTypeCardDetails;
